import { assert } from "../assert";
import { isFunc } from "../fn";
import { gqlFetcher } from "./fetcher";
import { Operation } from "./operation";

export * from "./GqlError";
export * from "./HttpError";

const decorateFetcher = (fetcher, middlewares) => {
	let execute;

	const restart = (...args) => execute(...args);

	execute = middlewares.reduceRight(
		(next, middleware) => middleware(next, restart, fetcher), // decorating fetcher
		fetcher,
	);

	return execute;
};

/**
 * Creates GraphQL client (runner for GraphQL queries)
 */
export const createGqlClient = ({ uri, fetch, headers }, ...middlewares) => {
	assert(
		typeof uri === "string" && uri,
		`Expected uri to be not empty string but received: ${uri}`,
	);

	const fetcher = decorateFetcher(
		gqlFetcher(uri, headers, fetch), // pure fetcher
		middlewares.filter(isFunc), // middlewares
	);

	return (queryBuilder, variables, context = {}) =>
		fetcher(Operation(queryBuilder, variables), context);
};
